import React from 'react';
import DOMPurify from 'dompurify';

type TermsModalProps = {
    termsName: string;
    contents: string;
    onClose: () => void;
};

const TermsModal: React.FC<TermsModalProps> = ({
                                                     termsName,
                                                     contents,
                                                     onClose
                                                 }) => {

    const sanitizedContents = DOMPurify.sanitize(contents);

    return (
        <>
            <div className="modal" id="myModal">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3>{termsName}</h3>
                            <button type="button" className="close" onClick={onClose}>
                                <span className="blind">닫기</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="terms-wrap" dangerouslySetInnerHTML={{ __html: sanitizedContents }}>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="modal_btn">
                                <button type="button" className="btn cancle" onClick={onClose}>닫기</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop show"></div>
        </>
    );
};

export default TermsModal;
